/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export class CollectionActions {
    public static readonly CANCEL_ONEPASS_V2 = 'CANCEL_ONEPASS_V2';

    public static readonly CREATE_ONEPASS_V2 = 'CREATE_ONEPASS_V2';

    public static readonly MODIFY_ONEPASS_V2 = 'MODIFY_ONEPASS_V2';

    public static readonly DELETE_ALL_EPISODES = 'DELETE_ALL_EPISODES';

    public static readonly MORE_INFO = 'MORE_INFO';
}
